import moment from 'moment';
import browserHistory from '../../browserHistory';
import {
  CalendarActionNeededFilterIcon,
  CalendarExpiredOrWithdrawnIcon,
  CalendarOpenFilterIcon,
  CalendarTodayFilterIcon,
} from '../../images/emptyScreenIcons';
import { routes } from '../../routes';
import { Colors } from '../../themes/colors';
import { CONFIRM_CANDIDATE_LABEL, FilterStatusEnum, StatusEnum } from '../../utils/Enum';
import { getJobStatus } from '../Dashboard/ReceiptList/utils';

export function createDateArrayWithNumberOfDays(start, numberOfDays) {
  const dateArray = [];
  const startDate = moment(start);

  dateArray.push(startDate.format('YYYY-MM-DD'));

  while (dateArray.length < numberOfDays) {
    startDate.add(1, 'day');
    dateArray.push(startDate.format('YYYY-MM-DD'));
  }

  return dateArray;
}

export function createDaysOfWeekArray(start) {
  const daysArray = [];
  const startDate = moment(start).startOf('month');
  const endDate = moment(startDate).endOf('month');

  const firstDayOfGrid = moment(startDate).startOf('week');
  const lastDayOfGrid = moment(endDate).endOf('week');

  let currentDate = moment(firstDayOfGrid);

  while (currentDate.isSameOrBefore(lastDayOfGrid, 'day')) {
    daysArray.push(currentDate.format('YYYY-MM-DD'));
    currentDate.add(1, 'day');
  }

  return daysArray;
}

export const getCalendarJobStatus = (job) => {
  if (
    job.status === 'filled' &&
    moment(job.local_date, 'ddd, MMM D, YYYY').isSame(moment(), 'day')
  ) {
    return {
      label: StatusEnum.today,
      color: Colors.primary_500,
    };
  }
  return getJobStatus(job.is_canceled ? 'canceled' : job.status);
};

export const onCardClick = (job) => {
  let url = `/dashboard/job/${job.id}/details`;

  if (job.status === 'open' || job.status === 'pending' || job.status === 'counter') {
    url = `/dashboard/job/${job.id}`;
  }

  browserHistory.push(url);
  window.scrollTo(0, 0);
};

export const getEmptyFilteredScreen = (filter) => {
  switch (filter) {
    case FilterStatusEnum.OPEN:
      return {
        title: 'Post shifts, let us help you!',
        description: (
          <>
            You have not created any shifts.
            <br />
            Post a shift, to find the right professionals and
            <br />
            secure the coverage you need!
          </>
        ),
        buttonText: 'Post Shifts!',
        buttonLink: '/dashboard/multi-day/info',
        Icon: CalendarOpenFilterIcon,
      };
    case FilterStatusEnum.SCHEDULED:
      return {
        title: 'Ready to schedule your next candidate!',
        description: (
          <>
            You have no candidates scheduled.
            <br />
            Check to see if any candidates have applied to
            <br />
            your posted shifts!
          </>
        ),
        buttonText: `Go to ${CONFIRM_CANDIDATE_LABEL}`,
        buttonLink: routes.shiftsOverview.replace(':type', 'pending'),
        Icon: CalendarTodayFilterIcon,
      };
    case FilterStatusEnum.COMPLETED:
      return {
        title: 'Bring in your first professional!',
        description: (
          <>
            No professionals have completed their first shift
            <br />
            at your office yet. Start posting shifts to
            <br />
            welcome them in!
          </>
        ),
        buttonText: 'Post Shifts!',
        buttonLink: '/dashboard/multi-day/info',
        Icon: CalendarTodayFilterIcon,
      };
    case FilterStatusEnum.PENDING_COUNTER:
      return {
        title: 'Waiting for candidates to apply!',
        description: (
          <>
            No professionals have applied to your shifts yet.
            <br />
            Check back soon, someone might apply at any moment!
          </>
        ),
        Icon: CalendarActionNeededFilterIcon,
      };
    case FilterStatusEnum.CANCELLED_OR_EXPIRED:
      return {
        title: 'No cancelled or expired shifts',
        description: (
          <>
            You don’t have any cancelled or expired shifts
            <br />
            right now. Check back anytime. Any shifts that
            <br />
            weren’t filled or were cancelled will appear here.
          </>
        ),
        Icon: CalendarExpiredOrWithdrawnIcon,
      };
    default:
      return {
        title: 'No professionals stopping by today!',
        description: (
          <>
            There are no professionals booked for today.
            <br />
            Post a shift to get things rolling!
          </>
        ),
        Icon: CalendarTodayFilterIcon,
      };
  }
};
